const readingListStyle = Object.freeze({
  buttonVariant: 'neutral',
  checkBoxVariant: 'neutral',
  teaserHeaderTypeScale: null,
});

export default readingListStyle;
